import axios from 'axios'
// import {toast} from "vue3-toastify";
// import 'vue3-toastify/dist/index.css';
export default {
    data() {
        return {
            a: '',
        };
    },
    mounted() {
// alert('sd')
    },
    methods: {
        helperGet(action, param) {
            // let self = this;
            let link = action + '?' + param;
            link = this.$store.getters.baseUrl + '/' + link;
            return  axios.get(link,
                {
                    headers: {
                        'Content-Type': 'application/json',
                        'Authorization': 'Bearer ' + this.$store.getters.appToken
                    }
                }).
                then(function (r) {
                return r;
                }).catch(function () {
                // toast("خطای شبکه رخ داده", {
                //     "type": "error",
                //     "dangerouslyHTMLString": true
                // })
                })
        },
      helperPost(action, param) {
            param = typeof param == "undefined" ? {} : param;
             param.token =this.$store.getters.appToken;
            let link = this.$store.getters.baseUrl + '/' + action;
            return  axios.post(link, param, {
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': 'Bearer ' +this.$store.getters.appToken
                }
            }).then( r=>{
               return r;
                }).catch( function() {
                // toast("خطای شبکه رخ داده", {
                //     "type": "error",
                //     "dangerouslyHTMLString": true
                // })
                })
        },


        helperExcerpt(str, len) {
            if (typeof str != "string") {
                return str;
            }
            if (str.length > len) {
                return str = str.substring(0, len) + "...";
            }
            return str;
        },


        formatPrice(value) {
            let val = (value / 1).toFixed(0).replace(',', ',')
            return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")
        }

    }// --End Methods--
};
